<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>


export default {
  name: 'App',
  metaInfo() {
    return{
    title: 'Top Online Book Publishing platform in Africa ',
    titleTemplate: ' Tell! Books | %s',
     meta: [
                { name: 'description', content:  'Tell! Books provides a medium for young African creatives to seamlessly publish, monetize and distribute their creative works online'},
                { property: 'og:title', content: "Tell! Books | Top Online Book Publishing platform in Africa"},
                { property: 'og:site_name', content: 'Tell! Books'},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
  }
  }
}

</script>

<style lang='scss'>
</style>


// WEBPACK FOOTER //
// src/App.vue